import { render, staticRenderFns } from "./footbox.vue?vue&type=template&id=6755193a&scoped=true&"
import script from "./footbox.vue?vue&type=script&lang=js&"
export * from "./footbox.vue?vue&type=script&lang=js&"
import style0 from "./footbox.vue?vue&type=style&index=0&id=6755193a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755193a",
  null
  
)

export default component.exports